import { definePreset } from '@primevue/themes'
import Aura from '@primevue/themes/aura'

const Gleanin = definePreset(Aura, {
  // 1. PRIMITIVE TOKENS - Core color palette (no context)
  primitive: {
    // Font family
    fontFamily: {
      sans: 'Quicksand, Avenir, Helvetica, Arial, sans-serif',
    },
    // Brand Purple/Blue
    gleanin: {
      50: '#f0f4ff',
      100: '#e0e9ff',
      200: '#c7d7fe',
      300: '#a5b8fc',
      400: '#818cf8',
      500: '#5646fe', // Primary brand color
      600: '#4c40e6',
      700: '#4336d1',
      800: '#3730a3',
      900: '#312e81',
      950: '#1e1b4b',
    },
    // Accent colors
    cyan: {
      500: '#11eaff',
    },
    purple: {
      500: '#ac0fff',
    },
    blue: {
      500: '#2b64ff',
    },
  },

  // 2. SEMANTIC TOKENS - Only customize primary colors
  semantic: {
    // Font family
    fontFamily: {
      sans: '{fontFamily.sans}',
    },
    // Primary color mapping to use Gleanin brand colors
    primary: {
      color: '{gleanin.500}',
      contrastColor: '#ffffff',
      hoverColor: '{gleanin.600}',
      activeColor: '{gleanin.700}',
      50: '{gleanin.50}',
      100: '{gleanin.100}',
      200: '{gleanin.200}',
      300: '{gleanin.300}',
      400: '{gleanin.400}',
      500: '{gleanin.500}',
      600: '{gleanin.600}',
      700: '{gleanin.700}',
      800: '{gleanin.800}',
      900: '{gleanin.900}',
      950: '{gleanin.950}',
    },

    // Secondary button colors (for outlined and text buttons)
    secondary: {
      color: '{gleanin.500}',
      contrastColor: '{gleanin.500}',
      hoverColor: '{gleanin.50}',
      activeColor: '{gleanin.100}',
      50: '{gleanin.50}',
      100: '{gleanin.100}',
      200: '{gleanin.200}',
      300: '{gleanin.300}',
      400: '{gleanin.400}',
      500: '{gleanin.500}',
      600: '{gleanin.600}',
      700: '{gleanin.700}',
      800: '{gleanin.800}',
      900: '{gleanin.900}',
      950: '{gleanin.950}',
    },

    // Focus ring using brand color
    focusRing: {
      width: '2px',
      style: 'solid',
      color: '{gleanin.500}',
      offset: '2px',
    },
  },

  // Color scheme specific overrides - primary colors only
  colorScheme: {
    light: {
      primary: {
        color: '{gleanin.500}',
        contrastColor: '#ffffff',
        hoverColor: '{gleanin.600}',
        activeColor: '{gleanin.700}',
      },
    },
    dark: {
      primary: {
        color: '{gleanin.400}',
        contrastColor: '#ffffff',
        hoverColor: '{gleanin.600}',
        activeColor: '{gleanin.700}',
      },
    },
  },

  // 3. COMPONENT-SPECIFIC STYLING
  components: {
    button: {
      colorScheme: {
        dark: {
          text: {
            secondary: {
              color: '{gleanin.200}',
              contrastColor: '#ffffff',
            },
          },
        },
      },
    },
  },
})

export default Gleanin
